/* unplugin-vue-components disabled */import { render } from "./videoList.vue?vue&type=template&id=81f38bac&scoped=true&ts=true"
import script from "./videoList.vue?vue&type=script&lang=ts"
export * from "./videoList.vue?vue&type=script&lang=ts"

import "./videoList.vue?vue&type=style&index=0&id=81f38bac&scoped=true&lang=scss"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f38bac"],['__file',"src/components/video-list/videoList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81f38bac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81f38bac', __exports__)) {
    console.log('reload')
    api.reload('81f38bac', __exports__)
  }
  
  module.hot.accept("./videoList.vue?vue&type=template&id=81f38bac&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('81f38bac', render)
  })

}


export default __exports__